/*  ========================================================================
    # JavaScript - App
    ========================================================================  */

Array.prototype.contains = function (obj) {
  let i = this.length;
  while (i--) {
    if (this[i] == obj) {
      return true;
    }
  }
  return false;
};

function isBreakpoint(alias) {
  return jQuery('.device-' + alias).is(':visible');
}

function isEmpty(el) {
  return !jQuery.trim(el.html());
}

import jquery from 'jquery';

// Smooth Scroll
// =============================================================================

import SmoothScroll from 'smooth-scroll';

new SmoothScroll('a[href*="#"]', {
  // Selectors
  ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector).
  header: null, // Selector for fixed headers (must be a valid CSS selector).
  topOnEmptyHash: true, // Scroll to the top of the page for links with href="#".

  // Speed & Easing
  speed: 250, // Integer. Amount of time in milliseconds it should take to scroll 1000px.
  speedAsDuration: true, // If true, use speed as the total duration of the scroll animation.
  durationMin: null, // Integer. The minimum amount of time the scroll animation should take.
  durationMax: null, // Integer. The maximum amount of time the scroll animation should take.
  clip: true, // If true, adjust scroll distance to prevent abrupt stops near the bottom of the page.
  offset: 0, // How far to offset the scrolling anchor location in pixels.
  easing: 'easeInOutCubic', // Easing pattern to use.

  // History
  updateURL: false, // Update the URL on scroll.
  popstate: false, // Animate scrolling with the forward/backward browser buttons (requires updateURL to be true).

  // Custom Events
  emitEvents: true // Emit custom events.
});

// Search Contact Partner
// =============================================================================

function showWrongPlz() {
  jQuery('#wrong-plz').removeClass('display_none');
}
function hideWrongPlz() {
  jQuery('#wrong-plz').addClass('display_none');
}

function showBusinessCards(attrs) {
  jQuery('.business-card-box').each(function () {
    if (jQuery(this).attr('data-country').length > 0) {
      // business-card has data-county attribute
      const countries = jQuery(this).attr('data-country').split(',');
      if (countries.contains(attrs.country)) {
        // the correct country is selected

        if (attrs.country == 'country_de') {
          // if country is germany -> check if Post Code is correct

          const plz_areas = [];
          const plz_array = jQuery(this).attr('data-plz').split(',');
          jQuery.each(plz_array, function () {
            const fromTo = this.split('<');
            plz_areas.push({ from: parseInt(fromTo[0]), to: parseInt(fromTo[1]) });
          });
          // plz_areas is now an array with {from:xxx,to:yyy}-Objects

          let show = false;
          jQuery.each(plz_areas, (key, val) => {
            // go over all plz_areas of this businesscard and check if the attrs.plz fits
            if (attrs.plz >= val['from'] && attrs.plz <= val['to']) {
              show = true;
            }
          });

          if (show) {
            // if PLZ fits show card
            jQuery(this).parent().removeClass('display_none');
          } else {
            jQuery(this).parent().addClass('display_none');
          }
        } else {
          jQuery(this).parent().removeClass('display_none');
        }
      } else {
        jQuery(this).parent().addClass('display_none');
      }
    }
  });
}

function hideBusinessCards() {
  const allCountries = [];
  jQuery('.find-representation .business-card-box').each(function () {
    jQuery(this).parent().addClass('display_none');
    const thisCountries = jQuery(this).attr('data-country').split(',');
    thisCountries.forEach((item, index) => {
      if (!allCountries.contains(item)) allCountries.push(item);
    });
  });

  // hide options where no representation is available
  if (allCountries.length < 1) {
    jQuery('section.find-representation').remove();
  } else {
    jQuery('#contact_search_country_select option').each(function () {
      if (!allCountries.contains(jQuery(this).attr('value'))) {
        jQuery(this).remove();
      }
    });
    if (!allCountries.contains('country_de')) {
      jQuery('#post_code_wrapper').addClass('display_none');
      jQuery('#post_code').val('');
      showBusinessCards({
        country: jQuery('#contact_search_country_select option:first').val()
      });
    }
  }
}

function parseDate(str) {
  const y = str.substr(0, 4),
    m = str.substr(4, 2) - 1,
    d = str.substr(6, 2);
  const D = new Date(y, m, d);
  return D.getFullYear() == y && D.getMonth() == m && D.getDate() == d ? D : 'invalid date';
}

const qd = {};
if (location.search)
  location.search
    .substr(1)
    .split('&')
    .forEach(item => {
      const s = item.split('='),
        k = s[0],
        v = s[1] && decodeURIComponent(s[1]);
      (qd[k] = qd[k] || []).push(v);
    });

const searchParams = new URLSearchParams(window.location.search);

function getQueryString() {
  let key = false,
    res = {},
    itm = null;
  // get the query string without the ?
  const qs = location.search.substring(1);
  // check for the key as an argument
  if (arguments.length > 0 && arguments[0].length > 1) key = arguments[0];
  // make a regex pattern to grab key/value
  const pattern = /([^&=]+)=([^&]*)/g;
  // loop the items in the query string, either
  // find a match to the argument, or build an object
  // with key/value pairs
  while ((itm = pattern.exec(qs))) {
    if (key !== false && decodeURIComponent(itm[1]) === key) return decodeURIComponent(itm[2]);
    else if (key === false) res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2]);
  }

  return key === false ? res : null;
}

jQuery(document).ready($ => {
  // Show reCaptcchaBadge if page contains a form
  setTimeout(() => {
    if (jQuery('.wpcf7').length > 0) {
      jQuery('.grecaptcha-badge').css('visibility', 'visible');
    }
  }, 500);

  // Header Main Slider
  const headerMainTeaserRight = document.getElementById('header-main-teaser-right');

  if (typeof headerMainTeaserRight !== 'undefined' && headerMainTeaserRight != null) {
    setInterval(() => {
      headerMainTeaserRight.click();
    }, 8000);
  }

  let if_height;
  let src = 'https://recruitingapp-5449.de.umantis.com/Jobs/1?DesignID=10008';
  const job_id = getQueryString('job-id');
  if (job_id)
    src = 'https://recruitingapp-5449.de.umantis.com/Vacancies/' + job_id + '/Description/1';

  const iframe = $(
    '<iframe id="umantis-iframe-id" class="umantisiframe" src="' +
    src +
    '" name="' +
    document.location.href +
    '" width="100%" height="1000" frameborder="0" scrolling="yes"></iframe>'
  ).appendTo('#umantis_iframe');

  jQuery(window).on('message', e => {
    if ($('#umantis_iframe').length > 0 && e.originalEvent.data.length > 0) {
      const h = Number(e.originalEvent.data.replace(/.*if_height=(\d+)(?:&|$|\.\d+)/, '$1'));
      if (!isNaN(h) && h > 0 && h !== if_height) {
        /* Height has changed, update the iframe */
        if_height = h;
        iframe.height(h);
      }
    }
  });

  const parentiframe_autoresize =
    window != window.parent; /* Check if current content is loaded in an iframe */
  if (parentiframe_autoresize) {
    /* If so, periodically send content-height to the parent-window/iframe */
    const parent_url = window.name;
    function setCustomerHeight() {
      $('body').postMessage({ if_height: $('body').height() }, parent_url, parent);
    }
    setCustomerHeight();
    setInterval(setCustomerHeight, 500);
  }

  if (searchParams.get('top') > 10) {
    $('html, body').scrollTop(searchParams.get('top'));
  }

  if (isBreakpoint('xs') || isBreakpoint('sm')) {
    $('.filter-collapse').removeClass('show');
    $('.remove-sm-down').empty();
  }

  if (isBreakpoint('md') || isBreakpoint('lg') || isBreakpoint('xl')) {
    $('.remove-md-up').empty();
  }

  $.datepicker.regional.de = {
    closeText: 'Schließen',
    prevText: '&#x3C;Zurück',
    nextText: 'Vor&#x3E;',
    currentText: 'Heute',
    monthNames: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mär',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dez'
    ],
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    weekHeader: 'KW',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  };
  $.datepicker.setDefaults($.datepicker.regional.de);

  $('#date_from').datepicker();
  if (
    $('#date_from').attr('data-inputdate') &&
    $('#date_from').attr('data-inputdate').length == 8
  ) {
    $('#date_from').datepicker('setDate', parseDate($('#date_from').attr('data-inputdate')));
    $('#date_from + .fa-close').addClass('visible');
  }
  $('#date_to').datepicker();
  if ($('#date_to').attr('data-inputdate') && $('#date_to').attr('data-inputdate').length == 8) {
    $('#date_to').datepicker('setDate', parseDate($('#date_to').attr('data-inputdate')));
    $('#date_to + .fa-close').addClass('visible');
  }

  $('.meta-navi-button').click(function () {
    $('.meta-navi-tab').removeClass('active');
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('#' + targetId).removeClass('active');
      $('#main-navi').removeClass('with-meta-navi');
      $('#header-main').removeClass('with-meta-navi');
      $('header').removeClass('with-meta-navi');
    } else {
      var targetId = $(this).attr('data-targetid');
      $('#' + targetId).addClass('active');
      $('#main-navi').addClass('with-meta-navi');
      $('#header-main').addClass('with-meta-navi');
      $('header').addClass('with-meta-navi');
      $('.meta-navi-button').removeClass('active');
      $(this).addClass('active');
      if (targetId === 'meta-navi-tab-search') {
        document.getElementById('main_search').focus();
      }
    }
  });

  // representation-selection with PLZ-Filter and Country-Select
  // ===========================================================================

  $('#contact_search_country_select').change(function () {
    if ($(this).val() == 'country_de') {
      $('#post_code_wrapper').removeClass('display_none');
    } else {
      $('#post_code_wrapper').addClass('display_none');
    }
    $('#post_code').val('');
    showBusinessCards({ country: $(this).val() });
  });

  $('#post_code').on('input', function () {
    if ($(this).val().length == 5) {
      const plz = parseInt($(this).val());
      if (plz > 1000 && plz <= 99999) {
        showBusinessCards({ country: 'country_de', plz });
        hideWrongPlz();
      } else {
        hideBusinessCards();
        showWrongPlz();
      }
    } else if ($(this).val().length == 0) {
      hideBusinessCards();
      hideWrongPlz();
    } else {
      showWrongPlz();
      hideBusinessCards();
    }
  });

  hideBusinessCards();

  // Secret Downloads
  // ===========================================================================

  $('.secret-download').click(() => {
    const fileID = $('.secret-download').attr('data-fileid');
    $('#modal_guest_download_fileId').val(fileID);
  });

  // Navigation
  // ===========================================================================

  $('#menu-main-navi .menu-item').each(function () {
    const check = 'hover-';
    let navItem;

    // Get array of class names
    const cls = $(this).attr('class').split(' ');
    for (let i = 0; i < cls.length; i++) {
      // Iterate over the class and log it if it matches
      if (cls[i].indexOf(check) > -1) {
        navItem = cls[i].slice(check.length, cls[i].length);
      }
    }

    $('.submenus.hover-' + navItem)
      .mouseenter(() => {
        $('#menu-main-navi .menu-item.hover-' + navItem + ' a').addClass('hover');
      })
      .mouseleave(() => {
        $('#menu-main-navi .menu-item.hover-' + navItem + ' a').removeClass('hover');
      });
  });

  $('#navi-button').click(() => {
    if ($('#menu-main-navi').hasClass('active_mobile')) {
      $('#menu-main-navi').removeClass('active_mobile');
      $('#navi-button').removeClass('active_mobile');
      $('#navi-button i').removeClass('fa-close');
      $('#navi-button i').addClass('fa-navicon');
    } else {
      $('#menu-main-navi').addClass('active_mobile');
      $('#navi-button').addClass('active_mobile');
      $('#navi-button i').removeClass('fa-navicon');
      $('#navi-button i').addClass('fa-close');
    }
  });

  $('#country_select').change(function () {
    // alert($(this).val());
    if ($(this).val().indexOf('http') !== -1) {
      window.location = $(this).val();
    } else {
      window.location = location.protocol + '//' + $(this).val();
    }
  });

  resizeIframes();
  equalHeightColumns();

  $('#historySlider').on('slid.bs.carousel', () => {
    $('.hide-on-first').removeClass('invisible');
    $('.hide-on-last').removeClass('invisible');
    if ($('.history-slider-item-0').hasClass('active')) {
      $('.hide-on-first').addClass('invisible');
    }
    if ($('.history-slider-item-last').hasClass('active')) {
      $('.hide-on-last').addClass('invisible');
    }
  });

  // Show hide filter on mobile
  $('.sidebar-toggle').click(() => {
    if ($('.sidebar-wrapper').hasClass('active')) {
      $('.sidebar-wrapper').removeClass('active');
      $('.sidebar-toggle').removeClass('active');
    } else {
      $('.sidebar-wrapper').addClass('active');
      $('.sidebar-toggle').addClass('active');
    }
  });

  // VIMEO VIDEO GALLERY
  $('.video-thumbnail').click(event => {
    const target = $(event.target).closest('.video-thumbnail').attr('data-target');
    const vimeo_id = $(event.target).closest('.video-thumbnail').attr('data-vimeo');
    const vimeo_url = 'https://player.vimeo.com/video/' + vimeo_id;
    $('#' + target + ' iframe').attr('src', vimeo_url);
    $('#' + target + ' iframe').attr('data-vimeo', vimeo_id);
    updateThumbnails();
  });

  function updateThumbnails() {
    $('.video-thumbnail').each((index, element) => {
      const target = $(element).attr('data-target');
      const vimeo_id = $(element).attr('data-vimeo');
      const active_vimeo_id = $('#' + target + ' iframe').attr('data-vimeo');
      if (vimeo_id == active_vimeo_id) {
        $(element).addClass('active');
      } else {
        $(element).removeClass('active');
      }
    });
  }

  updateThumbnails();

  // make download links with icons alignment better
  $('a:not(.icon) > i.fa').each(function (obj, index) {
    $(this).parent().addClass('item-aligned');
  });

  // fix dropdown menu for touch devices
  $('.main-nav > li.menu-item > a').click(function () {
    if (!$(this).hasClass('navigatable') && $(this).siblings('.submenus').length > 0) {
      event.stopPropagation();
      event.preventDefault();
    }
  });

  $('.main-nav > li.menu-item > a').on('mouseover', function () {
    const self = this;
    window.setTimeout(() => {
      $(self).addClass('navigatable');
    }, 200);
  });
  $('.main-nav > li.menu-item > a').on('mouseout', function () {
    $(this).removeClass('navigatable');
  });

  $('body').toggleClass('touch-support', is_touch_device());

  $('.carousel').swiperight(function () {
    $(this).carousel('prev');
  });
  $('.carousel').swipeleft(function () {
    $(this).carousel('next');
  });

  function handleVideoSmoothScroll(event) {
    const modal = $(event.detail.toggle).attr('data-close-modal');
    if (modal) {
      $(modal).modal('hide');
    }
  }

  // listen to smooth scroll and for video cards
  document.addEventListener('scrollStart', handleVideoSmoothScroll, false);

  // Run traceparts iframe src replace
  reloadTracepartsIframeSrc();
});

jQuery(window).resize(() => {
  resizeIframes();
  jQuery('.carousel').carousel();
  equalHeightColumns();
});

function resizeIframes() {
  jQuery('.wysiwyg iframe').each(function () {
    const width = jQuery(this).attr('width');
    const height = jQuery(this).attr('height');
    jQuery(this).width('100%');
    const quot = jQuery(this).width() / width;
    jQuery(this).height(height * quot);
  });
}

function equalHeightColumns() {
  // make columns in sliders equal height
  jQuery('.header-overlay-container').removeAttr('style');
  jQuery('#headerSlider .carousel-item').removeAttr('style');
  jQuery('.carousel-inner').each(function () {
    let h = 0;
    jQuery(this)
      .children()
      .each(function () {
        if (jQuery(this).outerHeight() > h) {
          h = jQuery(this).outerHeight();
        }
      });
    if (h > 0) {
      jQuery(this)
        .children()
        .each(function () {
          jQuery(this).outerHeight(h);
        });
    }
  });
  if (isBreakpoint('xs') || isBreakpoint('sm')) {
    let h2 = 0;
    jQuery('.header-overlay-container').each(function (index) {
      if (index == 0) {
        h2 = jQuery(this).outerHeight();
      }
      if (jQuery(this).height() > h2) {
        h2 = jQuery(this).outerHeight();
      }
    });
  } else {
    //
  }
}

function is_touch_device() {
  return 'ontouchstart' in window || 'onmsgesturechange' in window;
}

// Accordion
jQuery(document).ready(() => {
  const $accordionItems = jQuery('.s-accordions__item');
  for (let index = 0; index < $accordionItems.length; index++) {
    const item = $accordionItems[index];
    jQuery(item).on('click', () => {
      if (jQuery(item).hasClass('s-accordions__item-active')) {
        jQuery(item).removeClass('s-accordions__item-active');
      } else {
        jQuery(item).addClass('s-accordions__item-active');
      }
    });
  }
});

// Reload 3D Data traceparts iframe if is in tab
function reloadTracepartsIframeSrc() {
  jQuery("[data-toggle='tab']").on('click', e => {
    const $tabToggle = jQuery(e.target);
    const $tabContent = jQuery($tabToggle[0].attributes.href.value);
    const $iframeElement = jQuery($tabContent[0]).find('iframe[src*="https://www.traceparts.com"]');

    if ($iframeElement.length > 0) {
      // Trigger src reset to load iframe after tab active
      $iframeElement[0].src = $iframeElement[0].src;
    }
  });
}
